"use client";

import { useEffect, useRef, useState } from "react";
import { ArrowRight } from "lucide-react";
import { Button } from "@/components/ui/button";
import { Link } from "@/components/common/Link";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
export default function ExploreOurTeachings() {
  const [scrollY, setScrollY] = useState(0);
  const [mousePos, setMousePos] = useState({
    x: 0,
    y: 0
  });
  const buttonRef = useRef<HTMLDivElement>(null);
  const {
    ref: containerRef,
    isVisible
  } = useRevealOnScroll({
    threshold: 0.3
  });
  useEffect(() => {
    const handleScroll = () => {
      setScrollY(window.scrollY);
    };
    window.addEventListener("scroll", handleScroll, {
      passive: true
    });
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);
  const handleMouseMove = (e: React.MouseEvent<HTMLDivElement>) => {
    if (!buttonRef.current) return;
    const rect = buttonRef.current.getBoundingClientRect();
    const centerX = rect.left + rect.width / 2;
    const centerY = rect.top + rect.height / 2;
    const deltaX = (e.clientX - centerX) / 10;
    const deltaY = (e.clientY - centerY) / 10;
    setMousePos({
      x: deltaX,
      y: deltaY
    });
  };
  const handleMouseLeave = () => {
    setMousePos({
      x: 0,
      y: 0
    });
  };
  return <section ref={containerRef} className="relative min-h-[80vh] w-full overflow-hidden bg-primary-dark" onMouseMove={handleMouseMove} onMouseLeave={handleMouseLeave}>
      {}
      <div className="absolute inset-0 bg-cover bg-center transition-transform duration-100 ease-out" style={{
      backgroundImage: "url(https://wpvc-images.s3.us-east-1.amazonaws.com/images/1444982/img/misty_forest_sunrise_background.png)",
      transform: `translateY(${scrollY * 0.3}px)`
    }}>
        <div className="absolute inset-0 bg-gradient-to-b from-primary-dark/40 via-primary-dark/20 to-primary-dark/60" />
      </div>

      {}
      <div className="relative z-10 flex min-h-[80vh] items-center px-6 py-20 sm:px-12 lg:px-20">
        <div className={`max-w-2xl transition-all duration-1000 ease-out ${isVisible ? "translate-x-0 opacity-100" : "-translate-x-12 opacity-0"}`}>
          {}
          
        </div>
      </div>
    </section>;
}